const fr = {
  common: {
    nav: { services: "Services", about: "À propos", guides: "Guides", contact: "Contact" },
    cta: "Lancer un projet",
    language: "Langue",
    themeToLight: "Passer en mode clair",
    themeToDark: "Passer en mode sombre",
    menuOpen: "Ouvrir le menu",
    menuClose: "Fermer le menu",
    optional: "facultatif",
    reply: "Nous répondons sous 7 heures.",
    scroll: "Défiler",
  },
  footer: {
    tagline: "Automatisation IA, sites et applications pour les équipes qui veulent confier les tâches répétitives à des systèmes.",
    company: "Entreprise",
    policies: "Politiques",
    elsewhere: "Réseaux",
    location: "Bikaner, Rajasthan, Inde · Partout dans le monde",
    legal: {
      terms: "Conditions générales",
      privacy: "Politique de confidentialité",
      refund: "Politique de remboursement",
      return: "Politique de retour",
      cancellation: "Politique d'annulation",
      shipping: "Politique de livraison",
    },
  },
  cookie: {
    title: "Des cookies, avec votre accord",
    body: "Nous utilisons des cookies essentiels au fonctionnement du site. Avec votre accord, nous utilisons aussi des cookies d'analyse pour l'améliorer.",
    accept: "Tout accepter",
    reject: "Essentiels uniquement",
    policy: "Politique de confidentialité",
  },
  cta: {
    title: "Un processus qui devrait tourner tout seul ?",
    body: "Dites-nous ce dont vous avez besoin. Nous répondons sous 7 heures.",
    primary: "Discutons-en",
    secondary: "Voir les services",
  },
  home: {
    hero: {
      eyebrow: "Studio d'automatisation IA et de logiciels",
      titleA: "Nous créons des systèmes",
      titleB: "qui travaillent pour vous.",
      lede: "Agents IA, automatisations, sites et applications — conçus, développés et livrés de bout en bout.",
      primary: "Lancer un projet",
      secondary: "Voir nos projets",
      tags: ["Agents IA", "Automatisation", "Apps web", "Apps mobiles", "Données", "Vidéo IA"],
    },
    marquee: ["Agents IA", "Systèmes RAG", "Automatisation", "Sites web", "Apps web", "Apps mobiles", "Web scraping", "Vidéo IA", "Python", "n8n"],
    stats: [
      { value: 4, suffix: "+", label: "ans à créer des systèmes IA" },
      { value: 100, suffix: "+", label: "processus automatisés" },
      { value: 7, suffix: "h", label: "délai de réponse maximum" },
    ],
    services: { label: "Ce que nous faisons", title: "Quatre façons de vous aider.", more: "Tous les services" },
    work: {
      label: "Réalisations",
      title: "Des projets en ligne, livrés par nous.",
      intro: "Ouvrez une carte pour voir le vrai site.",
      nextLabel: "Votre projet",
      nextTitle: "Le prochain, peut-être.",
      nextBody: "Sites, applications et automatisation, de bout en bout.",
      nextCta: "Parlez-nous-en",
      visit: "ouvrir le site dans un nouvel onglet",
    },
    process: {
      label: "Notre méthode",
      title: "De l'idée au lancement en quatre étapes.",
      steps: [
        { title: "Découvrir", desc: "Un appel gratuit pour comprendre votre objectif." },
        { title: "Cadrer", desc: "Un plan écrit clair, avec délais." },
        { title: "Construire", desc: "Des démos fonctionnelles à chaque étape." },
        { title: "Lancer", desc: "Mise en ligne, puis accompagnement." },
      ],
    },
    testimonials: { label: "Avis clients", title: "Ce que disent nos clients." },
  },
  services: {
    eyebrow: "Services",
    title: "Des services ciblés, pensés pour votre objectif.",
    lede: "Chaque projet commence par un appel découverte gratuit.",
    timeline: "Délai habituel",
    included: "Inclus",
    tools: "Nos outils",
    showTools: "Voir les outils",
    hideTools: "Masquer les outils",
    options: "Pour démarrer",
    choose: "Choisir",
    discuss: "Parlons de votre projet",
    extrasTitle: "Aussi disponible",
    extras: ["Conseil en IA", "Conception d'architecture", "Intégration d'API", "Cloud et DevOps", "Maintenance et support", "Ingénieurs dédiés"],
    items: {
      "ai-automation": {
        title: "Automatisation IA",
        tagline: "Des agents et assistants qui soulagent votre équipe des tâches répétitives.",
        timeline: "2–12 semaines",
        includes: ["Cartographie des processus", "Chatbots et agents IA", "Assistants de connaissances (RAG)", "Intégrations CRM et outils", "30 jours de support"],
        plans: [
          { name: "Automatisation de base", note: "Un processus · 2–3 semaines" },
          { name: "Suite d'automatisation", note: "Plusieurs processus · 4–6 semaines" },
          { name: "Systèmes IA entreprise", note: "Intégration complète · 8–12 semaines" },
        ],
      },
      "web-development": {
        title: "Sites et apps web",
        tagline: "Des sites et applications rapides, modernes et simples à gérer.",
        timeline: "1–10 semaines",
        includes: ["Design UI/UX", "Développement responsive", "Espace d'administration", "SEO et performance", "60 jours de support"],
        plans: [
          { name: "Site vitrine statique", note: "5–7 pages · 1–2 semaines" },
          { name: "Site dynamique avec admin", note: "Espace admin · 3–4 semaines" },
          { name: "Application web sur mesure", note: "Fonctions sur mesure · 6–10 semaines" },
        ],
      },
      "python-automation": {
        title: "Python et données",
        tagline: "Scripts, scrapers et pipelines qui tournent seuls.",
        timeline: "3 jours–4 semaines",
        includes: ["Scripts sur mesure", "Web scraping", "Traitement de données", "Tâches planifiées", "Logs et documentation"],
        plans: [
          { name: "Script d'automatisation", note: "Une tâche · 3–5 jours" },
          { name: "Solution de web scraping", note: "Plusieurs pages · 1–2 semaines" },
          { name: "Pipeline de données complexe", note: "Plusieurs sources · 2–4 semaines" },
        ],
      },
      "ai-video": {
        title: "Vidéo et avatars IA",
        tagline: "Du contenu vidéo en volume, sans monteurs.",
        timeline: "2–10 semaines",
        includes: ["Avatars personnalisés", "Synthèse vocale", "Du script à la vidéo", "Style de marque", "Formation de l'équipe"],
        plans: [
          { name: "Vidéo IA de base", note: "Un avatar · 2–3 semaines" },
          { name: "Système d'avatars pro", note: "Clonage de voix · 4–5 semaines" },
          { name: "Plateforme vidéo entreprise", note: "API et marque blanche · 6–10 semaines" },
        ],
      },
    },
  },
  about: {
    eyebrow: "À propos",
    title: "Une petite équipe qui crée une IA utile.",
    lede: "Nous remplaçons les tâches répétitives par des systèmes fiables — d'un script à une plateforme complète.",
    storyLabel: "Notre histoire",
    story: "Nous avons créé Optivra Tech pour mettre l'IA moderne au service du quotidien des entreprises. Nous comprenons d'abord votre façon de travailler, puis nous construisons ce qui convient.",
    valuesLabel: "Nos principes",
    values: [
      { title: "Mission", desc: "Une croissance mesurable grâce à une IA et une automatisation concrètes." },
      { title: "Vision", desc: "Le partenaire technologique des entreprises en croissance." },
      { title: "Engagement", desc: "Un travail soigné, une communication claire, des résultats réels." },
    ],
    skillsLabel: "Expertise",
    skillsTitle: "Nos points forts.",
    skillsHint: "Survolez ou touchez une carte pour voir les outils.",
    skills: [
      { title: "IA et ML", tools: "OpenAI · LangChain · RAG · PyTorch" },
      { title: "Backend", tools: "Python · FastAPI · Node.js · Django" },
      { title: "Frontend", tools: "React · Next.js · TypeScript · Tailwind" },
      { title: "Données", tools: "MongoDB · PostgreSQL · Redis · Pinecone" },
      { title: "Cloud", tools: "AWS · Google Cloud · Azure · Docker" },
      { title: "Automatisation", tools: "n8n · Selenium · Scrapy · Airflow" },
    ],
    teamLabel: "L'équipe",
    team: ["Ingénieurs IA et automatisation", "Développeurs full-stack", "Architectes solutions", "Ingénieurs DevOps"],
    whyLabel: "Pourquoi nous",
    why: [
      { title: "Rapides", desc: "Cycles courts, démos fonctionnelles." },
      { title: "À jour", desc: "Des outils éprouvés et actuels." },
      { title: "Propres", desc: "Code documenté et maintenable." },
    ],
  },
  contact: {
    eyebrow: "Contact",
    title: "Parlons-en.",
    lede: "Présentez-nous votre projet. Nous répondons sous 7 heures.",
    name: "Nom complet",
    email: "E-mail",
    phone: "Téléphone",
    subject: "Objet",
    subjectPh: "ex. Automatiser la facturation",
    message: "Message",
    messagePh: "De quoi avez-vous besoin, et avec quels outils ?",
    send: "Envoyer le message",
    sending: "Envoi…",
    privacy: "Nous ne partageons jamais vos données.",
    okTitle: "Message envoyé",
    okBody: "Merci ! Nous répondons sous 7 heures.",
    errTitle: "Une erreur est survenue",
    errBody: "Le message n'a pas pu être envoyé. Veuillez réessayer.",
    emailLabel: "E-mail",
    phoneLabel: "Téléphone",
    hoursLabel: "Horaires",
    hours: "Lun–Sam, 9h00–19h00 IST",
  },
  checkout: {
    eyebrow: "Lancer un projet",
    title: "Dites-nous ce dont vous avez besoin.",
    lede: "Choisissez l'option la plus proche. Nous confirmerons le périmètre avec vous.",
    details: "Vos coordonnées",
    project: "Projet",
    name: "Nom complet",
    company: "Entreprise",
    email: "E-mail",
    phone: "Téléphone",
    service: "Service",
    selectService: "Choisissez un service",
    option: "Option",
    selectOption: "Choisissez une option",
    notes: "Notes sur le projet",
    notesPh: "Que doit-il faire ? À quels outils doit-il se connecter ?",
    agree: "J'accepte les",
    and: "et la",
    submit: "Envoyer la demande",
    submitting: "Envoi…",
    summary: "Récapitulatif",
    summaryService: "Service",
    summaryOption: "Option",
    next: "Nous répondons sous 7 heures pour confirmer le périmètre et la suite.",
    empty: "Choisissez un service et une option.",
    perks: ["Traitement sécurisé", "Remboursement sous 7 jours", "Réponse sous 7 heures"],
    refundLink: "Politique de remboursement",
    termsTitle: "Conditions requises",
    termsBody: "Veuillez accepter les conditions pour continuer.",
    okTitle: "Demande reçue",
    okBody: "Merci ! Nous vous contactons sous 7 heures.",
    errTitle: "Une erreur est survenue",
    errBody: "La demande n'a pas pu être envoyée. Veuillez réessayer.",
  },
  guide: {
    eyebrow: "Guides",
    title: "Des guides pratiques tirés de vrais projets.",
    lede: "Des méthodes pas à pas sur l'IA, l'automatisation et la carrière.",
    badges: ["PDF téléchargeable immédiatement", "Copie envoyée par e-mail", "Paiement sécurisé via PhonePe"],
    listLabel: "Guides disponibles",
    listTitle: "Choisissez un guide.",
    mins: "min",
    levels: { "All Levels": "Tous niveaux", Beginner: "Débutant", Intermediate: "Intermédiaire", Advanced: "Avancé" },
    choose: "Choisir",
    selected: "Choisi",
    items: {
      g0: "Un plan de 30 à 45 jours pour décrocher le poste visé : CV, entretiens, prospection.",
      g1: "Modèles de diffusion, nœuds personnalisés et prototypage rapide dans ComfyUI.",
      g2: "Créez des systèmes autonomes qui remplacent le travail manuel.",
      g3: "Bases vectorielles, découpage et déploiement d'agents de connaissances.",
      g4: "Hébergez n8n et créez des flux multi-apps avec des webhooks.",
    },
    buyLabel: "Paiement",
    buyTitle: "Obtenez votre exemplaire.",
    buySub: "Utilisé pour votre facture et l'envoi du lien de téléchargement.",
    name: "Nom complet",
    phone: "Téléphone",
    email: "E-mail",
    country: "Pays",
    countries: { India: "Inde", "United States": "États-Unis", "United Kingdom": "Royaume-Uni", Canada: "Canada", Australia: "Australie", Germany: "Allemagne", Other: "Autre" },
    gst: "Numéro GST",
    company: "Nom de l'entreprise",
    agree: "J'accepte les",
    and: "et la",
    terms: "Conditions générales",
    refund: "Politique de remboursement",
    pay: "Payer {amount} en toute sécurité",
    redirecting: "Redirection vers le paiement…",
    buying: "Votre achat",
    format: "Guide PDF · téléchargement",
    price: "Prix",
    gstLine: "GST ({percent} %)",
    total: "Total",
    loadingPrice: "Chargement du prix…",
    methods: "Payez par UPI, carte, virement ou portefeuille.",
    secure: "Les paiements sont traités en toute sécurité par PhonePe.",
    faqLabel: "FAQ",
    faqTitle: "Questions fréquentes.",
    faqs: [
      { q: "Sous quel format sont les guides ?", a: "Un PDF avec schémas, extraits de code et instructions pas à pas." },
      { q: "Quand vais-je le recevoir ?", a: "Immédiatement. Vous arrivez sur une page de téléchargement et recevez une copie par e-mail." },
      { q: "Puis-je être remboursé ?", a: "Les guides étant des téléchargements immédiats, les remboursements sont limités. Voir notre Politique de remboursement." },
      { q: "Qui rédige les guides ?", a: "Nos ingénieurs, à partir des systèmes qu'ils créent pour nos clients." },
    ],
    errors: {
      "Full name is required": "Le nom complet est obligatoire",
      "Email is required": "L'e-mail est obligatoire",
      "Please enter a valid email": "Saisissez un e-mail valide",
      "Phone number is required": "Le téléphone est obligatoire",
      "Please enter a valid phone number": "Saisissez un numéro valide",
      "You must accept the terms": "Vous devez accepter les conditions",
      "Something went wrong. Please try again.": "Une erreur est survenue. Veuillez réessayer.",
    },
  },
  success: {
    verifying: "Confirmation du paiement…",
    pending: "Paiement en cours de traitement",
    checking: "Nouvelle vérification automatique ({n}/10)",
    checkAgain: "Vérifier à nouveau",
    paid: "Paiement reçu. Merci !",
    downloads: "Vos téléchargements",
    dlGuide: "Télécharger le guide (PDF)",
    dlInvoice: "Télécharger la facture (PDF)",
    linksNote: "Les liens sont valables 24 heures. Une copie vous a aussi été envoyée par e-mail.",
    expired: "Ce lien de téléchargement a expiré",
    failed: "Impossible de finaliser",
    support: "Contacter le support",
    home: "Retour à l'accueil",
    errors: {
      "No order ID found. Please check your payment email for order details.": "Commande introuvable. Consultez l'e-mail de paiement pour les détails.",
      "Payment failed. Please try again.": "Le paiement a échoué. Veuillez réessayer.",
      "Unable to verify payment status.": "Impossible de vérifier le statut du paiement.",
      "Download links have expired after 24 hours.": "Les liens ont expiré après 24 heures.",
      "Unable to fetch download links.": "Impossible de récupérer les liens de téléchargement.",
      "Download failed. Please try again or contact support.": "Le téléchargement a échoué. Réessayez ou contactez le support.",
      "Something went wrong.": "Une erreur est survenue.",
    },
  },
  legal: { notice: "Cette politique est publiée en anglais, seule version juridiquement contraignante." },
  work: {
    kke: { kind: "Site client", summary: "Catalogue multilingue pour un fournisseur industriel qui exporte dans le monde entier.", highlights: ["Anglais, français et arabe", "12 gammes de produits", "Devis et WhatsApp"] },
    pokemac: { kind: "Notre produit · app macOS", summary: "Une app ludique de barre de menus qui réagit aux tapes, à l'écran et à l'USB.", highlights: ["macOS natif", "100 % local"] },
    drillbuddy: { kind: "Notre produit · app Android", summary: "Des exercices de réaction audio pour la lutte, le MMA et le badminton.", highlights: ["Google Play", "Intensité réglable"] },
    prayer: { kind: "Notre produit · app Android", summary: "Un compteur de prières apaisant, avec thèmes et suivi quotidien.", highlights: ["8 langues", "Google Play"] },
  },
};

export default fr;
